export default "__VITE_ASSET__2377433d__"